import type { RouterContext } from 'universal-router';

import { isRouteActionContext } from 'src/routes/types';
import {
  ClientSettingsPage,
  getClientSettingsPath,
  getClientSettingsTerm,
  isClientSettingsPath,
  isClientSettingsTerm,
} from 'src/utils/clientSettingsPaths';

export const clientSettingsRoute = (page: ClientSettingsPage) => ({
  path: `/:clientTerm-${page}`,
  async action(context: RouterContext) {
    if (!isRouteActionContext(context)) return undefined;
    const term = getClientSettingsTerm(
      context.portalConfig.features.customLabels,
    );
    const requestedTerm = context.params.clientTerm;
    if (
      typeof requestedTerm !== 'string' ||
      !isClientSettingsTerm(requestedTerm, term)
    ) {
      return undefined;
    }
    const path = getClientSettingsPath(term, page);
    if (!isClientSettingsPath(context.pathname, term, page)) {
      return {
        redirect: `${path}${context.search ?? ''}${context.hash ?? ''}`,
      };
    }
    const module =
      page === 'authentication'
        ? await import(/* webpackChunkName: 'client-authentication' */ './auth')
        : await import(
            /* webpackChunkName: 'settings-client-notifications' */ './client-notifications'
          );
    return module.default(context);
  },
});
